import { replace } from 'react-router-redux';
import Url from 'url';

export default function redirectArticleRoute(dispatch, location) {
    return dispatch((thunkDispatch, getState) => {
        const { article } = getState();

        if (article.error) {
            return Promise.resolve();
        }

        const { canonicalUrl } = article.links || {};
        const canonicalPathname = Url.parse(article.links.canonicalUrl).pathname;
        if (canonicalPathname && canonicalPathname !== location.pathname) {
            let newLocation = canonicalUrl;
            if (location.search) {
                newLocation += location.search;
            }

            return thunkDispatch(replace(newLocation));
        }

        return Promise.resolve();
    });
}



/** WEBPACK FOOTER **
 ** ./src/utils/generate-article-route.js
 **/